<template>
  <!-- 单个带有续报科目的卡片，下含多个课程和商品 -->
  <!-- 此处判断样式只是为了原班推荐图标能贴边展示否则将有1像素白边 -->
  <div
    :class="[
      listType === 'change' ? 'card-tab-wrap-no-border' : 'card-tab-wrap',
      { 'value-buy-tab-wrap': info.isValueBuyGroup },
    ]"
    :id="
      info && info.title_info && info.title_info.learn_course_id
        ? `learn_course_id${info.title_info.learn_course_id}`
        : ''
    "
  >
    <!-- cnt_list下的title_info作为标题部分（粉色背景标题部分） -->
    <course-tab-title
      v-if="$$(info.title_info).title"
      :title="info.title_info.title"
    ></course-tab-title>
    <ValueBuyCard v-if="info.isValueBuyGroup" :info="info" />
    <div v-else-if="isSelectionModeCard" class="selection-mode-card-wrap">
      <div class="selection-mode-card">
        <div class="selection-mode-card-main">
          <div class="inner-box-title">
            <span class="inner-box-tag">{{
              $$(info.title_info).learn_subject_name
            }}</span
            >{{ info.title_info.sub_title }}
          </div>
        </div>
        <div
          :class="[
            'selection-mode-card-btn',
            {
              'selection-mode-card-btn-disabled': !isSelectionModeSelectable,
            },
          ]"
          @click="openSelectionPopup"
        >
          <span>选择年级时间</span>
        </div>
      </div>
    </div>
    <div v-else-if="info.isEmptyCourseCard" class="empty-package-info">
      暂无老学员报名课程
    </div>
    <div v-else class="select-card-wrap">
      <!-- 多个package_info只展示一个冲突提示 -->
      <noticeBar v-if="info.isClash" :text="info.clashMsg" showBorder />
      <!-- 单选按钮部分，每一个package_info对应一个单选按钮 -->
      <select-card
        v-for="(sItem, sIndex) in this.info.package_info"
        :showNotice="info.isClash && sIndex === 0"
        :key="sIndex"
        :package_info_index="sIndex"
        :package_info="sItem"
        :must_check="$$(info.title_info).must_check === 1"
        :isLast="isLastTab && sIndex === info.package_info.length - 1"
      />
    </div>
    <SelectionModePopup
      :info="info.title_info"
      ref="selectionModePopup"
      @confirm="handleSelectionConfirm"
    />
  </div>
</template>

<script>
import courseTabTitle from "./courseTabTitle.vue";
import SelectionModePopup from "./SelectionModePopup.vue";
import selectCard from "./selectCard.vue";
import ValueBuyCard from "./ValueBuyCard.vue";
import noticeBar from "../../../components/noticeBar.vue";
import { setSelectType, transfromGoodsInfo } from "../utils/formatData";
import { appendStuCourseIds } from "@/common/script/log-helper";
export default {
  provide() {
    return {
      tab_list_index: this.tab_list_index, // 为了在跳转二级页的时候组装参数
      isAddPriceBuy: this.info?.isAddPriceBuy, // 是否是加价购配置的课程
      change_info: this.info?.title_info?.change_info,
      current_title_info: this.info?.title_info,
      parent: this.info?.parent,
      switch_change: this.info?.title_info?.switch_change, // 加价购是否支持更换课程
    };
  },
  inject: ["listType", "cardType"],
  props: {
    tab_list_index: {
      type: Number,
      default: 0,
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isLastTab: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    noticeBar,
    selectCard,
    ValueBuyCard,
    courseTabTitle,
    SelectionModePopup,
  },
  computed: {
    isSelectionModeCard() {
      return (
        +this.info?.title_info?.selection_info?.selection_mode === 2 &&
        !(this.info?.package_info?.length > 0)
      );
    },
    isSelectionModeSelectable() {
      return this.info?.title_info?.selection_info?.is_can_select === true;
    },
    selectionModeText() {
      const title = this.info?.title_info?.title || "";
      if (!title) {
        return "续报活动";
      }
      let text = title
        .replace("课程老学员续报", "续报活动")
        .replace("老学员续报", "续报活动")
        .replace("课程续报", "续报活动");
      if (text === title) {
        text = title.replace("老学员", "").replace("课程", "").trim();
        if (text && !text.includes("活动")) {
          text = text.replace(/续报$/, "续报活动");
        }
      }
      return text || "续报活动";
    },
  },
  data() {
    return {
      showNotice: true,
    };
  },
  created() {
    console.log("info--", this.info);
  },
  methods: {
    openSelectionPopup() {
      if (!this.isSelectionModeSelectable) {
        return;
      }
      this.$xesLogger.clickMsg({
        params: appendStuCourseIds({
          click_id: "click_kY2mNp4Q",
          click_name: "选择年级时间点击",
          click_timestamp: Date.now(),
        }),
      });
      this.$refs.selectionModePopup?.open();
    },
    handleSelectionConfirm({ list = [], grade = "", time = "" }) {
      console.log("grade---", grade);
      console.log("time---", time);
      const normalizedList = Array.isArray(list) ? list : list ? [list] : [];
      const currentSelectType = this.info?.package_info?.[0]?.selectType;
      const hasCurrentSelectState = [1, 2].includes(currentSelectType);
      const defaultCheck = hasCurrentSelectState
        ? currentSelectType === 2
        : this.cardType === "raw"
        ? true
        : !!(
            this.info?.title_info?.check_status ||
            this.info?.title_info?.must_check
          );
      const packageInfo = transfromGoodsInfo(normalizedList).map((item) =>
        setSelectType(
          {
            ...item,
            cardType: this.cardType,
          },
          defaultCheck
        )
      );
      if (this.info?.title_info) {
        this.$set(this.info.title_info, "selection_filter", {
          grade_id: grade || "",
          class_time: time || "",
        });
      }
      this.$set(this.info, "package_info", packageInfo);
      this.$set(this.info, "isEmptyCourseCard", false);
      this.$set(this.info, "isClash", false);
      this.$set(this.info, "clashMsg", "");
      console.log("this.info---", this.info);
      this.$EventBus.$emit("selectionModeConfirm", {
        cardType: this.cardType,
      });
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/layout.less";

.card-tab-wrap {
  .only-bg('https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/title-bg-new.png', 100%, 80px);
  margin-top: 8px;
  position: relative;
  // border: 1px solid #fff;
  border-radius: 16px;
  overflow: hidden;
  background-color: #fff;
}

.card-tab-wrap-no-border {
  .card-tab-wrap;
  border: none;
}

.value-buy-tab-wrap {
  background: none;
  margin-top: 0;
}

.select-card-wrap {
  //   border: 1px solid #fff;
  border-radius: 16px 16px 0 0;
  background-color: #fff;
  box-sizing: border-box;
  overflow: hidden;
}

.empty-package-info {
  .flex-center-center;
  height: 178px;
  color: #666;
  font-family: PingFang SC;
  font-size: 13px;
  font-weight: 400;
  background-color: #fff;
}

.selection-mode-card-wrap {
  // padding: 2px 12px 12px;
  background-color: #fff;
  border-radius: 16px;
}

.selection-mode-card {
  position: relative;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  min-height: 78px;
  box-sizing: border-box;
  padding: 12px;
  // border: 1px solid #fff3ef;
  border-radius: 14px;
  overflow: hidden;
  // background: linear-gradient(180deg, #fffefd 0%, #fff9f7 100%);
  // box-shadow: 0 4px 12px 0 rgba(249, 56, 52, 0.06);
  // &::before {
  //   content: "";
  //   position: absolute;
  //   top: -24px;
  //   left: 42px;
  //   width: 108px;
  //   height: 108px;
  //   border-radius: 50%;
  //   background: radial-gradient(
  //     circle,
  //     rgba(255, 235, 227, 0.75) 0%,
  //     rgba(255, 235, 227, 0) 70%
  //   );
  //   pointer-events: none;
  // }
}

.selection-mode-card-main {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  margin-right: 14px;
}

// .selection-mode-card-tag {
//   flex-shrink: 0;
//   padding: 1px 7px;
//   border-radius: 7px;
//   background: linear-gradient(180deg, #f5d8a5 0%, #e6b66f 100%);
//   color: #fff;
//   font-family: PingFang SC;
//   font-size: 10px;
//   font-weight: 500;
//   line-height: 14px;
//   box-shadow: 0 1px 4px 0 rgba(230, 182, 111, 0.2);
// }
// .selection-mode-card-title {
//   margin-left: 4px;
//   color: #333;
//   font-family: PingFang SC;
//   font-size: 17px;
//   font-weight: 500;
//   line-height: 16px;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// }
.selection-mode-card-btn {
  position: relative;
  z-index: 1;
  margin-left: auto;
  margin-top: 15px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 112px;
  height: 28px;
  // padding: 3px 0px;
  border-radius: 38px;
  background: #f93834;
  color: #fff;
  font-family: PingFang SC;
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0;
  // span {
  //   width: 90px;
  //   margin: 4px;
  // }
  // box-shadow: 0 4px 10px 0 rgba(249, 56, 52, 0.16);
}

.selection-mode-card-btn-disabled {
  background: #9999991a;
  color: #adadad;
}

.inner-box-title {
  .ellipsis-two;
  color: #333;
  text-align: justify;
  font-family: PingFang SC;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  word-break: break-all;
}

.inner-box-tag {
  position: relative;
  top: -2px;
  margin-right: 4px;
  display: initial;
  white-space: nowrap;
  padding: 0 3px;
  border-radius: 4px;
  background-color: #e4a970;
  color: #fff;
  font-family: PingFang SC;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
}
</style>
